'use strict';

import { doAjaxFiltering } from './modules/filter';
import { DOM } from './modules/init';
import { enablePaginationEvents } from './modules/pagination';

const form = document.querySelector<HTMLFormElement>('form.blog__controls');
if (form) {
	// Add an event listener to all form elements that are not hidden <input> elements
	[...form.elements].forEach((element) => {
		if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement) && !(element instanceof HTMLTextAreaElement)) return;
		if (element.name.includes('filter_') && !(element.type && element.type === 'hidden')) {
			element.addEventListener('change', doAjaxFiltering);
		}
	});
}

// Add pagination event handler
document.addEventListener('afterPaginationInit', enablePaginationEvents);

// Reset filters
document.addEventListener(
	'click',
	function (e) {
		if (!(e.target instanceof Node)) return;
		// loop parent nodes from the target to the delegation node
		for (let target: Node | null = e.target; target && target != this; target = target.parentNode) {
			if (target instanceof Element && target.matches('.postfilter__reset')) {
				document.querySelector<HTMLFormElement>(DOM.form)?.reset();
				doAjaxFiltering();
				break;
			}
		}
	},
	false,
);
